import script from "./scanQRCodeSend.vue?vue&type=script&setup=true&lang=js"
export * from "./scanQRCodeSend.vue?vue&type=script&setup=true&lang=js"

import "./scanQRCodeSend.vue?vue&type=style&index=0&id=1443a20a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1443a20a"]])

export default __exports__